export const themeLight = {
  primary: '#0ea5e9', // sky-500
  textBase: '#23395d', // sky-900
  textLight: '#0369a1', // sky-700
  light: '#f0f9ff', // sky-50
  backgroundBase: '#FFFFFF', // white
  backgroundLight: '#f0f9ff', // sky-50
  backgroundMedium: '#e0f2fe', // sky-100
};

export const themeDark = {
  primary: '#0ea5e9',
  textBase: '#f3f6fc',
  textLight: '#bae6fd',
  light: '#0c4a6e',
  backgroundBase: '#141414',
  backgroundLight: '#0c4a6e',
  backgroundMedium: '#075985', // sky-800
  backgroundDarkItem: '#082f49', // sky-950
  backgroundDarkSumbMenuItem: '0c4a6e', // sky-900
};

/* <OLD THEME> */

// export const themeLight = {
//   primary: '#6366F1', // indigo-500
//   textBase: '#312E81', // indigo-900
//   textLight: '#4338ca', // indigo-700
//   light: '#EEF2FF', // indigo-50
//   backgroundBase: '#FFFFFF', // white
//   backgroundLight: '#EEF2FF', // indigo-50
//   backgroundMedium: '#e0e7ff', // indigo-100
// };

// export const themeDark = {
//   primary: '#6366F1',
//   textBase: '#EEF2FF',
//   textLight: '#a0a3ae',
//   light: '#312E81',
//   backgroundBase: '#141414',
//   backgroundLight: '#312E81',
//   backgroundMedium: '#3730a3', // indigo-800
// };

// </OLD THEME>;
